import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapRetrieve } from '../common/rest.operators';

import {
    validateWidgetGroup,
    WidgetGroup,
    WidgetGroupModelTransformer,
} from './config.widget.model';
import {
    DateRange,
    ExtPeriod,
    PeriodModelSetTransformer,
    validateDateRanges,
} from './date-range.widget.model';
import { Widgets } from './widget.model';

@Injectable()
export class WidgetService {
    widgets: Widgets;
    dateRange: BehaviorSubject<DateRange>;
    dateRangeCompliance: BehaviorSubject<DateRange>;

    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        this.widgets = [];
        this.dateRange = new BehaviorSubject(null);
        this.dateRangeCompliance = new BehaviorSubject(null);
    }

    dateRanges(): Observable<DateRange[]> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.WIDGET_DATA}/widgetdata/GetPeriods`,
            )
            .pipe(
                map((model: ExtPeriod[]) =>
                    new PeriodModelSetTransformer().transform(model),
                ),
                tap((model: DateRange[]) => validateDateRanges(model)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('GetPeriods failed');
                }),
            );
    }

    dateRangesCompliance(): Observable<DateRange[]> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.WIDGET_DATA}/widgetdata/GetPeriodsCompliance`,
            )
            .pipe(
                map((model: ExtPeriod[]) =>
                    new PeriodModelSetTransformer().transform(model),
                ),
                tap((model: DateRange[]) => validateDateRanges(model)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('GetPeriodsCompliance failed');
                }),
            );
    }

    widgetConfigurations(): Observable<WidgetGroup> {
        const params = new HttpParams().set('widgetGroupID', '1');

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.WIDGET_CONFIGURATION}/WidgetConfiguration/GetWidgetConfigurations`,
                { params },
            )
            .pipe(
                mapRetrieve(new WidgetGroupModelTransformer()),
                tap((model: WidgetGroup) => validateWidgetGroup(model)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('GetWidgetConfigurations failed');
                }),
            );
    }
}
